// extracted by mini-css-extract-plugin
module.exports = {"modal_title":"styles_modal_title__3O7Vu","modal_desc":"styles_modal_desc__EmZv4","button__disagree":"styles_button__disagree__25dhc","button__agree":"styles_button__agree__1m_uT"};